import { FormControlLabel, Switch, Tooltip } from '@mui/material';
import { QuestionBase } from '@synergetx/puppet-interview-types';
import { useField } from 'formik';
import { memo } from 'react';

interface Props {
    position: number;
}

function RequiredField({ position }: Props) {
    const [{ value: question }, , { setValue: setQuestion }] = useField<QuestionBase>(
        `questions[${position}]`,
    );

    return (
        <Tooltip title={`Require assessors to provide a response for this question`}>
            <span>
                <FormControlLabel
                    control={
                        <Switch
                            value={!!question?.required}
                            checked={!!question?.required}
                            onClick={(e) => {
                                e.stopPropagation();
                            }}
                            onChange={(e, checked) =>
                                setQuestion({ ...question, required: checked })
                            }
                        />
                    }
                    label="Required"
                    labelPlacement="start"
                />
            </span>
        </Tooltip>
    );
}

export default memo(RequiredField);
